// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var ClassNames = require("./ClassNames.bs.js");

var make = ClassNames.make;

var ifBool = ClassNames.ifBool;

var ifOpt = ClassNames.ifOpt;

var mapOpt = ClassNames.mapOpt;

exports.make   = make;
exports.ifBool = ifBool;
exports.ifOpt  = ifOpt;
exports.mapOpt = mapOpt;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ./node_modules/re-classnames/lib/js/src/Cn.bs.js
// module id = 15
// module chunks = 0